<template>
    <v-list-item align="left" class="kimsa-elevation" v-if="invitation">
        <v-list-item-avatar size="50" color="grey">
            <v-img v-if="invitation.coach.avatar" :src="invitation.coach.avatar"></v-img>
            <v-icon v-else>mdi-account</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
            <v-list-item-title class="text-truncate">
                {{ coach.name }}
            </v-list-item-title>

            <v-list-item-subtitle class="text-truncate">
                {{ timestamp }} |
                <span :class="statusIcon.color">
                    <v-icon size="14" :class="statusIcon.color">{{ statusIcon.icon }}</v-icon>
                  {{ status }}
                </span>
            </v-list-item-subtitle>

            <v-list-item-title>
                <template v-if="invitation.status === 'pending'">
                    <v-btn x-small color="success" class="mr-1" @click="accept">{{ $t('common.accept') }}</v-btn>
                    <v-btn x-small color="error" @click="reject">{{ $t('common.reject') }}</v-btn>
                </template>
            </v-list-item-title>
        </v-list-item-content>

        <kimsa-confirm
            ref="acceptInvitationDialog"
            :title="$t('student.dialog_accept_invitation_title')"
            :content="$t('student.dialog_accept_invitation_body')"
            :loading="loadingAccept"
            :close-on-confirm="false"
            :confirm-label="$t('common.accept')"
            @confirm="acceptConfirm"
        />

        <kimsa-confirm
            ref="rejectInvitationDialog"
            :title="$t('student.dialog_reject_invitation_title')"
            :content="$t('student.dialog_reject_invitation_body')"
            :loading="loadingReject"
            :close-on-confirm="false"
            :confirm-label="$t('common.accept')"
            @confirm="rejectConfirm"
        />
    </v-list-item>
</template>

<script>

import firebase from '@/utils/Firebase'
import KimsaConfirm from "@/components/common/KimsaConfirm";

export default {
    components: {KimsaConfirm},
    props: {
        invitation: {
            type: Object,
            default: null,
        }
    },
    data() {
        return {
            operationType: 'accept',
            loadingAccept: false,
            loadingReject: false,
        }
    },
    computed: {
        coach() {
            const vm = this
            return vm.invitation?.coach || null
        },
        timestamp() {
            const vm = this
            if (!vm.invitation.createdAt) return ''
            return vm.$moment(vm.invitation.createdAt.seconds * 1000).fromNow()
        },
        status() {
            const vm = this
            if (!vm.invitation) return vm.$t('common.invitation_status.pending')
            return vm.$t(`common.invitation_status.${vm.invitation.status}`)
        },
        statusIcon() {
            const vm = this
            if (vm.invitation.status === 'pending') return {icon: 'mdi-timer-sand', color: 'grey--text'}
            if (vm.invitation.status === 'accepted') return {icon: 'mdi-check-circle-outline', color: 'success--text'}
            return {icon: 'mdi-block-helper', color: 'error--text'}
        }
    },
    methods: {
        acceptInvitation: firebase.functions().httpsCallable('httpInvitations-acceptStudentInvitation'),
        rejectInvitation: firebase.functions().httpsCallable('httpInvitations-rejectStudentInvitation'),
        async acceptConfirm() {
            const vm = this
            const payload = {invitationID: vm.invitation.id}
            vm.loadingAccept = true

            vm.acceptInvitation(payload).then(result => {
                // console.log('accept result', result)
                vm.toast(vm.$t('student.invitation_accepted'))
                if (vm.$refs.acceptInvitationDialog) vm.$refs.acceptInvitationDialog.hide()
                vm.$emit('accepted')
            }).catch(err => {
                vm.toast(`${vm.$t('common.an_error_has_occurred')}: ${err.message}`, 'error')
            }).finally(() => {
                vm.loadingAccept = false
            })
        },
        async rejectConfirm() {
            const vm = this
            const payload = {invitationID: vm.invitation.id}
            vm.loadingReject = true

            vm.rejectInvitation(payload).then(result => {
                // console.log('reject result', result)
                vm.toast(vm.$t('student.invitation_rejected'))
                if (vm.$refs.rejectInvitationDialog) vm.$refs.rejectInvitationDialog.hide()
                vm.$emit('reject')
            }).catch(err => {
                vm.toast(`${vm.$t('common.an_error_has_occurred')}: ${err.message}`, 'error')
            }).finally(() => {
                vm.loadingReject = false
            })
        },
        accept() {
            const vm = this
            vm.$refs.acceptInvitationDialog.show()
        },
        reject() {
            const vm = this
            vm.$refs.rejectInvitationDialog.show()
        },
    },
}
</script>

<style scoped>

</style>